(function($) {

  $(document).ready(function() {

    var $navbar = $("#mainNavbar");

    var $hamburger = $(".hamburger");

    $hamburger.on("click", function(e) {
      if ($navbar.hasClass('show')) {

        $hamburger.removeClass("is-active");
      } else {
        $hamburger.addClass("is-active");
      }
    });

  });

})(jQuery);
